import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiService } from './services/api.service';
import { AuthenticationService } from './services/authentication.service';
import { NotificationService } from './services/notification.service';
import { RoleService } from './services/role.service';
import { GlobalErrorHandler } from './handlers/global-error.handler';
import { LanguageService } from './services/language.service';

/**
 * CoreModule
 *
 * Singleton module that centralizes services and global configurations
 * de la aplicacion. Solo debe importarse UNA VEZ en AppModule (o via
 * importProvidersFrom en app.config.ts).
 *
 * Servicios registrados:
 * - ApiService: cliente HTTP base para la API backend
 * - AuthenticationService: management de session y tokens
 * - NotificationService: sistema de notificaciones UI (snackbar)
 *
 * El guard del constructor previene importaciones multiples accidentales.
 */
@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [ApiService, AuthenticationService, NotificationService, RoleService, GlobalErrorHandler, LanguageService],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule ya esta cargado. Solo debe importarse en AppModule o app.config.ts.'
      );
    }
  }
}
